import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function ArrowLeftIcon(props) {
    return (
        <SvgIcon stroke="currentColor" strokeWidth={1.5} {...props}>
            <path d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
}

export default ArrowLeftIcon;
